import * as React from 'react';
import { SVGProps } from 'react';

const SvgNoContent = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    width={196}
    height={196}
    viewBox="0 0 196 196"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <g clipPath="url(#no-content_svg__a)">
      <circle cx={98} cy={98} r={98} fill="#E8EEFF" />
      <rect
        x={110.573}
        y={59.237}
        width={11.331}
        height={3.022}
        rx={1.511}
        transform="rotate(20 110.573 59.237)"
        fill="#E8ECEE"
      />
      <rect
        x={93.52}
        y={106.088}
        width={11.331}
        height={3.022}
        rx={1.511}
        transform="rotate(20 93.52 106.088)"
        fill="#E8ECEE"
      />
      <g filter="url(#no-content_svg__b)">
        <path
          d="M48.695 55.442a4 4 0 0 1 3.244-4.634l43.332-7.64 27.803 19.467 11.808 66.967a4 4 0 0 1-3.245 4.634L68.609 145.35a4 4 0 0 1-4.633-3.245L48.695 55.442Z"
          fill="#fff"
        />
        <path d="M123.074 62.635 95.271 43.168l3.473 19.696a4 4 0 0 0 4.634 3.244l19.696-3.473Z" fill="#DCE1E4" />
      </g>
      <rect x={57.789} y={60.946} width={33} height={3} rx={1.5} transform="rotate(-10 57.789 60.946)" fill="#DCE1E4" />
      <rect x={64.677} y={94.256} width={54} height={3} rx={1.5} transform="rotate(-10 64.677 94.256)" fill="#DCE1E4" />
      <rect x={66.933} y={104.52} width={38} height={3} rx={1.5} transform="rotate(-10 66.933 104.52)" fill="#DCE1E4" />
      <rect x={63.46} y={84.824} width={38} height={3} rx={1.5} transform="rotate(-10 63.46 84.824)" fill="#DCE1E4" />
      <rect
        x={68.669}
        y={114.369}
        width={42}
        height={3}
        rx={1.5}
        transform="rotate(-10 68.67 114.369)"
        fill="#DCE1E4"
      />
      <rect x={59.178} y={68.825} width={15} height={3} rx={1.5} transform="rotate(-10 59.178 68.825)" fill="#DCE1E4" />
      <rect
        x={69.944}
        y={129.883}
        width={15}
        height={3}
        rx={1.5}
        transform="rotate(-10 69.944 129.883)"
        fill="#DCE1E4"
      />
      <g filter="url(#no-content_svg__c)">
        <path
          d="M73.945 45.118a4 4 0 0 1 4.27-3.711l43.892 3.069 22.268 25.616-4.744 67.834a4 4 0 0 1-4.269 3.711l-63.844-4.464a4 4 0 0 1-3.711-4.27l6.138-87.785Z"
          fill="#fff"
        />
        <path d="m144.375 70.092-22.268-25.616-1.395 19.951a4 4 0 0 0 3.711 4.27l19.952 1.395Z" fill="#DCE1E4" />
      </g>
      <rect x={81.438} y={52.659} width={33} height={3} rx={1.5} transform="rotate(4 81.438 52.659)" fill="#DCE1E4" />
      <rect x={80.063} y={86.646} width={54} height={3} rx={1.5} transform="rotate(4 80.063 86.646)" fill="#DCE1E4" />
      <rect x={79.769} y={97.151} width={38} height={3} rx={1.5} transform="rotate(4 79.769 97.15)" fill="#DCE1E4" />
      <rect x={81.164} y={77.2} width={38} height={3} rx={1.5} transform="rotate(4 81.164 77.2)" fill="#DCE1E4" />
      <rect x={79.071} y={107.126} width={42} height={3} rx={1.5} transform="rotate(4 79.071 107.126)" fill="#DCE1E4" />
      <rect x={80.879} y={60.639} width={15} height={3} rx={1.5} transform="rotate(4 80.88 60.64)" fill="#DCE1E4" />
      <rect x={76.555} y={122.488} width={15} height={3} rx={1.5} transform="rotate(4 76.555 122.488)" fill="#DCE1E4" />
      <circle cx={131.5} cy={132.5} r={16} fill="#184F81" />
      <path d="M128 124.5c-1.1 0-2 .9-2 2v14l6-3 6 3v-14c0-1.1-.9-2-2-2h-8Z" fill="#fff" />
    </g>
    <defs>
      <filter
        id="no-content_svg__b"
        x={-7.367}
        y={11.168}
        width={198.31}
        height={214.244}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={2} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.12 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_5_82" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={4} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.04 0" />
        <feBlend in2="effect1_dropShadow_5_82" result="effect2_dropShadow_5_82" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={8} />
        <feGaussianBlur stdDeviation={12} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.08 0" />
        <feBlend in2="effect2_dropShadow_5_82" result="effect3_dropShadow_5_82" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={24} />
        <feGaussianBlur stdDeviation={28} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.08 0" />
        <feBlend in2="effect3_dropShadow_5_82" result="effect4_dropShadow_5_82" />
        <feBlend in="SourceGraphic" in2="effect4_dropShadow_5_82" result="shape" />
      </filter>
      <filter
        id="no-content_svg__c"
        x={3.797}
        y={1.397}
        width={204.578}
        height={228.25}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={2} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.12 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_5_82" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={8} />
        <feGaussianBlur stdDeviation={8} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.08 0" />
        <feBlend in2="effect1_dropShadow_5_82" result="effect2_dropShadow_5_82" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={12} />
        <feGaussianBlur stdDeviation={16} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.04 0" />
        <feBlend in2="effect2_dropShadow_5_82" result="effect3_dropShadow_5_82" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={24} />
        <feGaussianBlur stdDeviation={32} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.08 0" />
        <feBlend in2="effect3_dropShadow_5_82" result="effect4_dropShadow_5_82" />
        <feBlend in="SourceGraphic" in2="effect4_dropShadow_5_82" result="shape" />
      </filter>
      <clipPath id="no-content_svg__a">
        <rect width={196} height={196} rx={98} fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgNoContent;
